export const platformKey = "X-Platform-Key";
